<template>
  <span v-if="getDate" class="task-name-time">
    {{ this.$t('msg.by') }} <date-string :value="getDate" short></date-string>
  </span>
</template>

<script>
import DateString from "@/components/ui/DateString";

export default {
  components: {DateString},
  props: {
    value: {type: String}
  },
  computed: {
    getDate() {

      if (typeof this.value === 'string') {
        return this.value.substring(0, 10);
      }

      return null;
    }
  }
}
</script>